module.exports = __webpack_public_path__ + "static/img/service.4e50be7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lifePay/service.png
// module id = k9Qx
// module chunks = 2